import { HttpClient } from "@angular/common/http";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { dateUtil } from "src/app/support/date-util";
import { from, Observable } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import {
  loadDemoStorage,
  writeDemoStorage
} from "src/app/support/demo-storage";
import { UserNotify } from "src/app/support/notify-decorator";
import { Paginated } from "src/app/support/paginated";
import { PaginatedResult } from "src/app/support/paginated-result";
import { rxRandomErrorDelayAsync } from "src/app/support/rx-random-error-delay";
import { uuid } from "src/app/support/uuid";
import { environment } from "src/environments/environment";
import { TemplateReporting } from "../../models/template-reporting/template-reporting";
import { TemplateReportingCreate } from "../../models/template-reporting/template-reporting.create";
import { TemplateReportingLoad } from "../../models/template-reporting/template-reporting.load";
import { TemplateReportingUpdate } from "../../models/template-reporting/template-reporting.update";
import { TemplateReportingBackend } from "./template-reporting.backend";

const DB_NAME = "template-reporting";

export class TemplateReportingMockBackend extends TemplateReportingBackend {
  constructor(private http: HttpClient) {
    super();
  }

  list(): Observable<TemplateReporting[]> {
    return this.http
      .get<PaginatedResult<TemplateReporting>>(
        `${environment.snoots.api.diagnostic}/templates`
      )
      .pipe(map((result) => result.docs));
  }

  load(request: TemplateReportingLoad): Observable<TemplateReporting> {
    return this.http.get<TemplateReporting>(
      `${environment.snoots.api.diagnostic}/templates/${request.id}`
    );
  }

  @UserNotify({
    successMessage: marker("Templare creato"),
    errorMessage: marker("Impossibile creare il template")
  })
  create(request: TemplateReportingCreate): Observable<string> {
    return this.http
      .post<TemplateReporting>(
        `${environment.snoots.api.diagnostic}/templates`,
        request
      )
      .pipe(map((x) => x.id));
  }

  @UserNotify({
    errorMessage: marker("Impossibile aggiornare il template")
  })
  update(
    id: string,
    request: Partial<TemplateReportingUpdate>
  ): Observable<void> {
    return this.http.patch<void>(
      `${environment.snoots.api.diagnostic}/templates/${id}`,
      request
    );
  }

  @UserNotify({
    successMessage: marker("Modello eliminato"),
    errorMessage: marker("Impossibile eliminare il template")
  })
  delete(id: string): Observable<void> {
    return this.http.delete<void>(
      `${environment.snoots.api.diagnostic}/templates/${id}`
    );
  }
}

async function loadDb(): Promise<TemplateReporting[]> {
  return (await loadDemoStorage<TemplateReporting[]>(DB_NAME)) || [];
}
